import { forwardRef } from 'react';
import styled from '@emotion/styled';

import { Flex, FlexProps } from '@bucketplace/design-system';

export const Container = forwardRef<HTMLElement, FlexProps>(({ children, ...props }, ref) => {
  return (
    <Flex
      ref={ref}
      as="section"
      direction="column"
      position="relative"
      w="100vw"
      h="100vh"
      align="center"
      justify="center"
      overflow="hidden"
      opacity={0}
      {...props}
    >
      { children }
    </Flex>
  );
});

export const SectionContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const ScrollControl = styled.div`
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
`;
